import React from 'react';
import PropTypes from "prop-types";
import CloseIcon from "../../media/images/CloseIcon.mjs";
import "./SliderPanel.css";
import Glob from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";

const SliderPanel = class extends React.Component {
	static propTypes = {
		/** Panel title */
		title: PropTypes.oneOfType([PropTypes.string,PropTypes.node]).isRequired,
		/** Panel ID, if any */
		id: PropTypes.string,
		/** Function invoked when panel is closed */
		close: PropTypes.func,
		/** Title icon */
		icon: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
		/** Full-size window */
		full: PropTypes.bool,
		/** If modal don't show close button */
		modal: PropTypes.bool,
		/** Optional alternative close icon */
		closeIcon: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
		className: PropTypes.string,
		children: PropTypes.node
	}
	constructor(props) {
		super(props);
		const cn = ['slider-panel','slider-panel-fade'];
		if (props.className) cn.push(props.className);
		if (props.full) cn.push('slider-panel-full');
		this.state = { status: 'hidden', className: cn.join(' ') };
		this.activate = this.activate.bind(this);
	}
	componentDidMount() {
		setTimeout( this.activate, 100 );
	}
	activate() {
		this.setState({status:'visible'}, ()=>{
			if ( ! appLib.isSmall() ) return;
			if ( ! Glob.getStatus('slider') ) return;
			Glob.setStatus('slider', false);
		} );
	}
	close() {
		Glob.gotoHomePage();
	}
	render() {
		return(
			<div
				className={`${this.state.className} status-${this.state.status}${this.props.modal?' slider-panel-modal':''}`}
				id={ this.props.id }
			>
				<h4>
					{ this.props.icon }
					<span>{ this.props.title }</span>
					<span onClick={ ()=>{
						this.setState({status:'hidden'},()=>{
							setTimeout( this.props.close ? this.props.close : this.close, 300 );
						});
					}}>
						{ this.props.closeIcon ?? <CloseIcon /> }
					</span>
				</h4>
				<div className={"panel-content"}>
					{ this.props.children }
				</div>
			</div>
		)
	}
}

export default SliderPanel;
